import {
  Button,
  DatePicker,
  Divider,
  Drawer,
  Input,
  InputNumber,
  Typography,
  Select,
} from "antd";
import axios from "axios";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../context";
import dayjs from "dayjs";
import moment from "moment";
import TextArea from "antd/es/input/TextArea";
import { SearchOutlined } from "@ant-design/icons";

const CreateInventoryReport = ({
  open,
  close,
  getProductInventoryReport,
  productList,
  filteredProduct,
}) => {
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const [finalArray, setFinalArray] = useState([]);
  //   const editedArray = [];
  const [startDateTime, setStartDateTime] = useState(null);
  const [momentStartDatetime, setMomentStartDatetime] = useState(null);
  const [endDateTime, setEndDateTime] = useState(null);
  const [momentEndDatetime, setMomentEndDatetime] = useState(null);
  const [remarks, setRemarks] = useState(null);
  const { rerunNotif } = useContext(NotificationInfo);
  const [search, setSearch] = useState("");

  //   console.log("userData: ", userData.data.id);

  const updateQuantityById = (id, newValue, oldArray) => {
    var array = [...oldArray];
    if (newValue !== null) {
      const updatedItem = filteredProduct.find((item) => item.id === id);
      if (updatedItem) {
        updatedItem.quantity = newValue;
        const itemAlreadyInArray = array.some(
          (item) => item.id === updatedItem.id
        );

        if (!itemAlreadyInArray) {
          array.push({ ...updatedItem });
        } else {
          const index = array.findIndex((item) => item.id === updatedItem.id);
          if (index !== -1) {
            array[index].quantity = newValue;
          }
        }
      } else {
        console.log("Item not found in filteredProduct array");
      }

      // if (updatedItem !== -1) {
      //   array.splice(updatedItem, 1);
      // }
      // console.log("updatedItem: ", updatedItem);
      // updatedItem.quantity = newValue;
      // array.push({ ...updatedItem });
    } else {
      const indexToRemove = array.findIndex((item) => item.id === id);
      if (indexToRemove !== -1) {
        array.splice(indexToRemove, 1);
      }
    }
    return array;
  };

  const handleCreateInventoryReport = () => {
    const formdata = new FormData();
    formdata.append("employee_id", userData.data.id);
    formdata.append(
      "merchant_id",
      userData.data.usersmerchantemployee.merchant_user_id
    );
    formdata.append("start_datetime", momentStartDatetime);
    formdata.append("end_datetime", momentEndDatetime);
    formdata.append("remarks", remarks);
    formdata.append("stored_data", JSON.stringify(finalArray));

    // setDisable(true);
    axios
      .post("user/merchant/create/product-inventory-report", formdata)
      .then((response) => {
        const data = response.data;
        console.log("DATA: ", data);
        if (data === "success") {
          rerunNotif("success", "Inventory report created successfully");
          setTimeout(() => {
            // setDisable(false);
            // setLoading(false);
            getProductInventoryReport();
            close();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  // console.log("finalArray: ", finalArray);

  const searchable = filteredProduct.filter((data) => {
    return data.product.toLowerCase().indexOf(search.toLowerCase()) >= 0;
  });

  return (
    <Drawer
      title="Creating Inventory Report"
      width={window.innerWidth > 400 ? 400 : "100vw"}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <Typography style={{ marginBottom: 20, fontWeight: "bold" }}>
        Note:{" "}
        <span style={{ fontStyle: "italic", color: "red" }}>
          Input the actual quantity of the specific product while checking your
          stack room.
        </span>
      </Typography>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          width: "100%",
          marginBottom: 10,
        }}
      >
        <div
          style={{
            flexGrow: 1,
            maxWidth: "30%",
          }}
        >
          <Typography style={{ fontWeight: "bold" }}>Start Time</Typography>
        </div>
        <div
          style={{
            width: "70%",
          }}
        >
          <DatePicker
            format={"YYYY-MM-DD HH:mm"}
            size="large"
            style={{ width: "100%", marginBottom: 2 }}
            showTime
            value={startDateTime !== null ? startDateTime : ""}
            // onChange={(e) => console.log("startDateTime: ", e)}
            name="start_datetime"
            onChange={(value, dateString) => {
              var date = moment(dateString).format("YYYY-MM-DD HH:mm");
              setMomentStartDatetime(moment(date).format("YYYY-MM-DD HH:mm"));
              setStartDateTime(dayjs(value, "YYYY-MM-DD HH:mm"));
            }}
            onOk={(e) => console.log("onOk: ", e)}
            clearIcon={false}
          />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          width: "100%",
          marginBottom: 10,
        }}
      >
        <div
          style={{
            flexGrow: 1,
            maxWidth: "30%",
          }}
        >
          <Typography style={{ fontWeight: "bold" }}>End Time</Typography>
        </div>
        <div
          style={{
            width: "70%",
          }}
        >
          <DatePicker
            format={"YYYY-MM-DD HH:mm"}
            size="large"
            style={{ width: "100%", marginBottom: 2 }}
            showTime
            value={endDateTime !== null ? endDateTime : ""}
            name="end_datetime"
            onChange={(value, dateString) => {
              var date = moment(dateString).format("YYYY-MM-DD HH:mm");
              setMomentEndDatetime(moment(date).format("YYYY-MM-DD HH:mm"));
              setEndDateTime(dayjs(value, "YYYY-MM-DD HH:mm"));
            }}
            onOk={(e) => console.log("onOk: ", e)}
            clearIcon={false}
          />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          width: "100%",
          marginBottom: 10,
        }}
      >
        <div
          style={{
            flexGrow: 1,
            maxWidth: "30%",
          }}
        >
          <Typography style={{ fontWeight: "bold" }}>Status</Typography>
        </div>
        <div
          style={{
            width: "70%",
          }}
        >
          <Select
            placeholder="Select status"
            // onChange={handleGetValueBarangay}
            onChange={(e) => setRemarks(e)}
            size="large"
            // showSearch
            style={{ width: "100%" }}
            // disabled={allowEdit}
            value={remarks !== null ? remarks : ""}
          >
            <Select.Option value={"beginning"}>BEGINNING</Select.Option>
            <Select.Option value={"ending"}>ENDING</Select.Option>
          </Select>
          {/* <TextArea
            size="large"
            // style={{ textTransform: "uppercase" }}
            autoSize={{
              minRows: 4,
            }}
            value={remarks !== null ? remarks : ""}
            onChange={(e) => setRemarks(e.target.value)}
          /> */}
        </div>
      </div>
      <Divider />
      <div style={{ marginBottom: 10 }}>
        <Input
          id="search"
          placeholder="Search product"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            // border: "2px solid #e5e5e5",
            // width: window.innerWidth < 576 ? "100%" : 300,
            width: "100%",
          }}
          size="large"
          addonBefore={<SearchOutlined />}
        />
      </div>

      {searchable.length > 0 &&
        searchable.map((data, index) => (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              width: "100%",
              marginBottom: 10,
            }}
            key={index}
          >
            <div
              style={{
                flexGrow: 1,
                maxWidth: "70%",
              }}
            >
              <Typography style={{ fontWeight: "bold" }}>
                {data.product}
              </Typography>
            </div>
            <div
              style={{
                width: "30%",
              }}
            >
              <InputNumber
                min={0}
                max={999999999999}
                size="large"
                style={{ width: "100%" }}
                step="1"
                onChange={(e) =>
                  setFinalArray(updateQuantityById(data.id, e, finalArray))
                }
                // value={
                //   data.quantity !== "" && data.quantity !== null
                //     ? data.quantity
                //     : ""
                // }
              />
            </div>
          </div>
        ))}

      <Divider />

      {console.log("finalArray: ", finalArray)}

      <Button
        type="primary"
        loading={loadings}
        style={{ width: "100%", borderRadius: "20px" }}
        disabled={
          finalArray.length < 1 ||
          startDateTime === null ||
          endDateTime === null
        }
        onClick={handleCreateInventoryReport}
      >
        Create
      </Button>
    </Drawer>
  );
};

export default CreateInventoryReport;
